<div class="mt-3" id="signature-tab">
  <mat-expansion-panel expanded="true" class="mat-elevation-z0" disabled>
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title panel-title">
        {{ "title.settings_footnote" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form nz-form>
      <nz-table #rowsTable nzBordered [nzData]="dataFootNote" [nzShowPagination]="false" [nzFrontPagination]="false"
        style="overflow-x: auto !important;" class="ant-table-no-placeholder-border-bottom">
        <thead>
          <tr>
            <th class="text-center" nzWidth="10%"> 
              {{ "enterprise_contract.panel_document.table_users.header.order_sign" | translate }}</th>
            <th class="text-center" nzWidth="30%">
              {{ "enterprise_contract.panel_document_view.table_user_forward.member" | translate }}
            </th>
            <th class="text-center" nzWidth="10%">
              {{ "enterprise_contract.table_headers.role" | translate }}
            </th>
            <th class="text-center" nzWidth="20%">
              {{ "enterprise_contract.table_headers.choose_sign" | translate }}
            </th>
            <th class="text-center" nzWidth="30%">
              {{ "signature_config.real_page" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of listDataPeople; let j = index">
            <tr>
              <td class="text-left" style="background-color: #FFEDF1; color: black; font-weight: bold;">{{data.order}}</td>
              <td colspan="4" style="background-color: #FFEDF1; color: black; font-weight: bold;">
                <!--            {{ "enterprise_contract.sign_table.approve_sign" | translate }}-->
                {{data.name}}
              </td>
            </tr>
            <tr *ngFor="let element of data.customerApproves; let i = index">
              <td class="text-right" *ngIf="(element.role == 2 || element.role == 7)">{{ i + 1 }}</td>
              <td *ngIf="element.role == 1"></td>
              <td style="word-break: break-word">
                {{ element.name  }}
              </td>
              <td class="text-center" *ngIf="element.role == 1">{{'enterprise_contract.buttons.sign' | translate }}</td>
              <td class="text-center" *ngIf="element.role == 2 || element.role == 7">
                {{'enterprise_contract.buttons.approve' | translate }}</td>
              <td *ngIf="element.role == 1 && element.isCreatedSide">
                <input nz-input [(ngModel)]="element.signatureName" disabled [title]="element.signatureName" type="text"
                  [ngModelOptions]="{ standalone: true }" id="inputUser" />
              </td>
              <td *ngIf="element.role == 2 && element.isCreatedSide">
                <nz-select nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }"
                  class="td-nz-input" [nzDisabled]="!optionsSignApprover.length"
                  (ngModelChange)="changeSelect($event, element,i,j)">
                  <nz-option *ngFor="let option of optionsSignApprover" [nzLabel]="option.signature.name"
                    [nzValue]="option.signature.signatureId"></nz-option>
                </nz-select>
              </td>
              <td *ngIf="(element.role == 2 || element.role == 7) && !element.isCreatedSide">
                <nz-select nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }"
                  class="td-nz-input" [nzDisabled]="!optionsApproverCustomer1.length"
                  (ngModelChange)="changeSelect($event, element,i,j)">
                  <nz-option *ngFor="let option of optionsApproverCustomer1" [nzLabel]="option.signature.name"
                    [nzValue]="option.signature.signatureId"></nz-option>
                </nz-select>
              </td>
              <td *ngIf="element.role == 1 && !element.isCreatedSide">
                <nz-select nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }"
                  class="td-nz-input" [nzDisabled]="!optionsSignCustomer.length"
                  (ngModelChange)="changeSelect($event, element,i,j)">
                  <nz-option *ngFor="let option of optionsSignCustomer" [nzLabel]="option.signature.name"
                    [nzValue]="option.signature.signatureId"></nz-option>
                </nz-select>
              </td>
              <td class="text-center">
                {{  element.page }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </form>
    <p class="mt-4">{{ "signature_tab.note" | translate }}</p>
  </mat-expansion-panel>
</div>